import { FC } from 'react'
import { Navigate } from 'react-router-dom'
import { TableCard } from '../../../../../components/Table/TableCard'
import { TableErrorState } from '../../../../../components/Table/TableStates'
import { DetailPanel } from '../../../../../components/DetailPanel/DetailPanel'
import { extrairErrosProtocolo } from '../../core/errosProtocolo'
import { ConteudoVersaoLeitura } from '../../components/ConteudoVersaoLeitura'
import { ModeloPlataformaDetalheHeading } from './components/ModeloPlataformaDetalheHeading'
import { useVersaoModelo } from './core/useVersaoModelo'

/** Detalhe de uma versão do modelo da plataforma, com publicar (sem CRM). */
export const ModeloPlataformaDetalhePage: FC = () => {
  const { data: versao, isLoading, isError, error, refetch, catalogo } = useVersaoModelo()

  if (error && extrairErrosProtocolo(error).status === 403) {
    return <Navigate to='/error/404' />
  }

  if (isError) {
    return (
      <TableCard>
        <TableErrorState title='Não foi possível carregar a versão do modelo.' onRetry={refetch} />
      </TableCard>
    )
  }

  if (isLoading || !versao) {
    return (
      <TableCard>
        <DetailPanel isLoading loadingLabel='Carregando versão do modelo…' />
      </TableCard>
    )
  }

  return (
    <>
      <ModeloPlataformaDetalheHeading
        versao={versao}
        catalogo={catalogo}
        onPublicado={() => refetch()}
      />
      <TableCard>
        <ConteudoVersaoLeitura
          hash={versao.hash}
          regras={versao.conteudo?.protocolo?.regras}
          formulario={versao.conteudo?.formulario}
          catalogo={catalogo}
        />
      </TableCard>
    </>
  )
}
